module.exports = __webpack_public_path__ + "img/24775412000323.6b4140ff.png";